module.exports = __webpack_public_path__ + "img/icon-write.a54b55f4.svg";